<template>
	<db-row :width="width" :height="height" class="blend-text-wrapper" align="center">
		<db-col valign="middle" width="110%" height="110%" align="center" class="text-wrapper">{{text}}</db-col>
		<db-col class="pic-wrapper" width="100%">
			<db-col class="pic-inner" width="200%">
				<db-col width="50%" class="pic-boxer"></db-col>
				<db-col width="50%" class="pic-boxer"></db-col>
			</db-col>
			<db-col class="pic-inner2" width="200%">
				<db-col width="50%" class="pic-boxer"></db-col>
				<db-col width="50%" class="pic-boxer"></db-col>
			</db-col>
		</db-col>
	</db-row>
</template>

<script>
	export default {
		name: 'blend-text',
		
		props: {
			width: {
				type: [String, Number],
				default: '100%'
			},
			
			height: {
				type: [String, Number],
				default: '100%'
			},
			
			text: {
				type: [String, Number, Boolean],
				default: '豆包网'
			},
			
			pic: {
				type: String,
				default: ''
			},
			
			size: {
				type: [String, Number],
				default: 81
			}
		},
		
		computed: {
			style(){
				return {
					fontSize: parseInt(this.size) / 75 + 'rem'
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.blend-text-wrapper{
		position: relative;
		overflow: hidden;
		
		.text-wrapper{
			position: absolute;
			left: 0;
			top: 0;
			z-index: 2;
			font-size: 81px;
			//font-weight: bold;
			font-style: italic;
			//letter-spacing: 8px;
			color: #000;
			background: #fff;
			mix-blend-mode: lighten;
			margin: -1% -5%;
			text-shadow: 0 0 2px 2px #000;
		}
		
		.pic-wrapper{
			position: relative;
			background: #f0f0f0;
			overflow: hidden;
			
			.pic-inner{
				position: absolute;
				animation: loop 2.5s infinite linear;
			}
			.pic-inner2{
				position: absolute;
				animation: loop2 2.5s infinite linear;
			}
				
			
			.pic-boxer{
				background: linear-gradient(90deg, #f0f0f0, #999, #f0f0f0);
			}
		}
		
		@keyframes loop{
			0%{
				opacity: 1.0;
				transform: translateX(-50%);
			}
			50%{
				opacity: 1.0;
				transform: translateX(0);
			}
			100%{
				opacity: 0;
				transform: translateX(-50%);
			}
		}
		@keyframes loop2{
			0%{
				opacity: 0;
				transform: translateX(-50%);
			}
			50%{
				opacity: 0;
				transform: translateX(-50%);
			}
			100%{
				opacity: 1.0;
				transform: translateX(0);
			}
		}
	}
</style>
